import React from "react";
import { Icon } from "../Icon";

const Fact = ({ children }) => {
  return (
    <div className="flex flex-row  items-center lg:py-0 py-4">
      <Icon type="checkmark" className="w-6 h-6 text-orange-light mr-4 " />
      <span className="xl:text-3xl text-sm font-bold truncate xl:max-w-md max-w-[225px]">
        {children}
      </span>
    </div>
  );
};

const Highlights = ({ children, label }) => {
  return (
    <div className="w-full h-full my-10 lg:py-7 bg-blue-dark text-white text-center">
      <div className="container flex flex-col">
        <h2 className="xl:text-6xl text-5xl font-bold pt-8 text-white">
          {label}
        </h2>
        <div className="flex lg:justify-around justify-center items-center pt-7 pb-9 lg:flex-row flex-col">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Object.assign(Highlights, { Fact });
